import React, { useEffect, useState } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { useConstructor } from "../utils";

export const SidePanelComponent = (props) => {

    const [panelBody, setPanelBody] = useState(null);
    const [panelTitle, setPanelTitle] = useState("");
    const [openPanel, setOpenPanel] = useState(false);
    const [context, setContext] = useState(null);

    useConstructor(() => {
        props.openEvent.subscribe((panelBody, title, getContext) => {
			openSidePanel(panelBody, title, getContext);
		});
        props.closeEvent.subscribe(() => {
            setOpenPanel(false)
        })
    })

    const openSidePanel = (panel) => {
		let panelBody = panel.body;
		let panelTitle = panel.title;
		setPanelBody(panelBody);
        setPanelTitle(panelTitle);
        setOpenPanel(true);
        if (panel.getContext)
            setContext(getButtons(panel.getContext()));
	}
	
	const closePanel = () => {
        setOpenPanel(false);
    }

    return (
        <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            isOpen={openPanel}
            title={panelTitle}
            onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                closePanel();
            }}
        >
            <div style={{position: 'fixed', zIndex: '2', backgroundColor: 'white', width: '98%', marginTop: '-24px', marginLeft: '-32px'}}>
            {context}
            </div>
            {panelBody}
      </SlidingPane>
    )
}

const getButtons = (context) => {
    const buttons = [];
    const traverse = (obj) => {
      if (!obj || typeof obj !== "object") return;
      if (obj.submenu && obj.submenu.actions && obj.submenu.actions.options) {
        for (const key in obj.submenu.actions.options) {
          const option = obj.submenu.actions.options[key];
          if (option.label && option.do && typeof option.do === "function") {
            buttons.push(
              <button key={option.label} style={{ minWidth: '5rem' }} onClick={(e) => option.do(e)} type="button" className={'reject-button'} >
                {option.label}
              </button>
            );
          }
        }
      }
      else {
        for (const key in obj) {
            traverse(obj[key]);
        }
      }
    };
  
    traverse(context);
    return buttons;
}